export var PROMPT_TYPE = /* @__PURE__ */ ((PROMPT_TYPE2) => {
  PROMPT_TYPE2["CHOICE_PROMPT"] = "choice_prompt";
  PROMPT_TYPE2["GLOBAL_UNHANDLED_INTENT"] = "global_unhandled_intent";
  return PROMPT_TYPE2;
})(PROMPT_TYPE || {});
export var EVAL_TYPE = /* @__PURE__ */ ((EVAL_TYPE2) => {
  EVAL_TYPE2["ACCURACY"] = "accuracy";
  return EVAL_TYPE2;
})(EVAL_TYPE || {});
